import { Button, Table } from "antd";
import { UserOutlined, DeleteOutlined } from "@ant-design/icons";
import { ratingData } from "src/static/data";
import { ratingColumns } from "src/static/data/columns";
import RegionFilter from "src/components/filter/RegionFilter";

function RatingPage() {
  return (
    <div className="container rating">
      <div className="subjects-header">
        <h3>Test natijalari reytingi</h3>
        <p>
          O'zingizning viloyatingiz yoki o'zingizga tegishli bo'lgan fanda o'z
          reytiningiz bilan tanishing
        </p>
      </div>

      <div className="rating-filter">
        <RegionFilter />
        <Button icon={<DeleteOutlined />} size="large" type="primary">
          Filterni tozalash
        </Button>
      </div>
      <br />
      <Button icon={<UserOutlined />} size="large" danger>
        Meni ko'rsat
      </Button>

      <div className="rating-content">
        <Table size="large" dataSource={ratingData} columns={ratingColumns} />
      </div>
    </div>
  );
}

export default RatingPage;
